import { render, staticRenderFns } from "./axis.md?vue&type=template&id=73eced14&"
import script from "./axis.md?vue&type=script&lang=js&"
export * from "./axis.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73eced14')) {
      api.createRecord('73eced14', component.options)
    } else {
      api.reload('73eced14', component.options)
    }
    module.hot.accept("./axis.md?vue&type=template&id=73eced14&", function () {
      api.rerender('73eced14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/test/axis.md"
export default component.exports